// src/pages/SalesLedger/SalesLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchSalesLedger, fetchSaleAccounts } from "./SalesLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  accounts: [],
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const salesLedgerSlice = createSlice({
  name: "salesLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSaleAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload;
      })
      .addCase(fetchSalesLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSalesLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = salesLedgerSlice.actions;
export default salesLedgerSlice.reducer;
